import axiosCustom from "@/utils/axiosCustom";
import IRate from "@/models/protocols/IRate";
import { Defaults } from "@/types/Defaults";
import { CartItem } from "@/types/cart-item";
import IProduct from "@/models/protocols/IProduct";

export default class RatesService {
  static async get(
    item: CartItem,
    region: string,
    product: IProduct
  ): Promise<IRate[]> {
    const body = {
      promocode: product.promo_code,
      policyState: region,
      userType:
        product.user_type && product.user_type.length > 0
          ? product.user_type[0].value
          : "",
      productCode: product.product_code,
      product_property_type_id: product.product_property_type_id,
      classCode: product.product_property_type_id,
      deductible: item.deductible,
      coverageAmount: item.coverage,
      coverageType: product.coverage_types[0].value,
    };
    console.log("BODY", product);
    const { data } = await axiosCustom.post("/rest/V1/WAG/wise/rates", body);
    data.rates = data.rates.map((item) => {
      const found = product.policy_terms?.find(
        (option) => option.text === item.term
      );

      return {
        ...item,
        term_value: found ? found.value : null,
      };
    });
    //data.rates = rates;
    data.rates.school_indicator = data.school_indicator;
    console.log("Rates", data);
    return data.rates;
  }
}
